import { isIE11 } from '@/utils/browserCheck'

export function getHashPath () {
  const hash = window.location.hash
  if (hash) {
    if (hash.indexOf('?') > -1) {
      return hash.substring(hash.lastIndexOf('#') + 1, hash.lastIndexOf('?'))
    }
    return hash.slice(1)
  }
  return null
}

export function clearHash (reload = false) {
  if (isIE11()) {
    window.location.hash = ''
  } else {
    history.replaceState(null, null, ' ')
  }

  if (reload) {
    window.location.reload()
  }
}
